import React from 'react'
import { array, object, func } from 'prop-types'

import { Button } from 'react-bootstrap'

import QueryEditor from 'coact/QueryEditor'


function Reporter (props) {
  const { query, setQuery, fields, schema, download } = props
  return (
    <div>
      <h3 style={{ marginBottom: 10 }}>請假統計下載</h3>
      <div>
        <QueryEditor
          {...{
            value: query,
            onChange: setQuery,
            fields,
            schema,
          }}
        />
        <div>
          <Button bsStyle="primary" onClick={download}>下載</Button>
        </div>
      </div>
    </div>
  )
}
Reporter.propTypes = {
  query: object.isRequired,
  setQuery: func.isRequired,
  fields: array.isRequired,
  schema: object.isRequired,

  download: func.isRequired,
}

module.exports = Reporter



// WEBPACK FOOTER //
// ./src/components/LeavesReporter/LeavesReporter.jsx